import styled, { css } from "styled-components";
import { pxToRem } from "styles/utils";
import {
  ModalOverlayBase,
  ModalSurfaceBase,
} from "components/Modals/ModalPrimitives";

export const ModalOverlay = styled(ModalOverlayBase)``;

export const ModalContent = styled(ModalSurfaceBase)`
  width: min(${pxToRem(420)}, calc(100vw - ${pxToRem(40)}));
  padding: ${pxToRem(22)};
`;

export const ModalHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: ${({ theme }) => pxToRem(theme.spacing.md)};

  h2 {
    margin: 0;
    color: ${({ theme }) => theme.colors.ink};
    font-size: ${({ theme }) => pxToRem(theme.fontSize.xl)};
    font-weight: 600;
    letter-spacing: -0.01em;
  }
`;

export const SubText = styled.p`
  margin: ${pxToRem(5)} 0 ${pxToRem(18)};
  color: ${({ theme }) => theme.colors.inkSoft};
  font-size: ${({ theme }) => pxToRem(theme.fontSize.md)};
`;

export const FieldGroup = styled.div`
  margin-bottom: ${pxToRem(14)};
`;

export const FieldLabel = styled.label`
  display: block;
  margin-bottom: ${pxToRem(6)};
  color: ${({ theme }) => theme.colors.inkSoft};
  font-size: ${({ theme }) => pxToRem(theme.fontSize.md)};
`;

export const FieldWrap = styled.div`
  position: relative;
`;

export const Input = styled.input<{ $hasError?: boolean }>`
  width: 100%;
  height: ${pxToRem(42)};
  padding: 0 ${({ theme }) => pxToRem(theme.spacing.sm)};
  border: ${pxToRem(1)} solid ${({ theme }) => theme.borders.field};
  border-radius: ${({ theme }) => pxToRem(theme.radii.md)};
  background: ${({ theme }) => theme.colors.white};
  color: ${({ theme }) => theme.colors.ink};
  font: inherit;
  font-size: ${({ theme }) => pxToRem(theme.fontSize.lg)};
  font-variant-numeric: tabular-nums;
  outline: none;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;

  ${({ $hasError, theme }) =>
    $hasError &&
    css`
      border-color: ${theme.colors.danger};
    `}

  &:hover:not(:disabled) {
    border-color: ${({ theme }) => theme.colors.brand};
  }

  &:focus-visible {
    border-color: ${({ theme }) => theme.colors.brand};
    box-shadow: inset 0 0 0 ${pxToRem(1)} ${({ theme }) => theme.colors.brand};
  }

  &:disabled {
    cursor: not-allowed;
    background: ${({ theme }) => theme.colors.surfaceFaint};
    color: ${({ theme }) => theme.colors.inkMuted};
  }
`;

export const AmountInput = styled(Input)`
  padding-right: ${pxToRem(78)};
`;

export const AllAction = styled.div`
  position: absolute;
  top: 50%;
  right: ${pxToRem(6)};
  transform: translateY(-50%);

  > button {
    width: auto;
    min-width: 0;
    max-width: none;
    height: ${pxToRem(30)};
    padding: 0 ${pxToRem(10)};
  }
`;

export const FieldHint = styled.div<{ $error?: boolean }>`
  min-height: ${({ theme }) => pxToRem(theme.fontSize.md)};
  margin-top: ${pxToRem(6)};
  color: ${({ $error, theme }) => ($error ? theme.colors.danger : theme.colors.inkMuted)};
  font-size: ${({ theme }) => pxToRem(theme.fontSize.sm)};
`;

export const ModalActions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: ${({ theme }) => pxToRem(theme.spacing.xs)};
  margin-top: ${({ theme }) => pxToRem(theme.spacing.lg)};

  > button {
    width: auto;
    min-width: ${pxToRem(110)};
    max-width: none;
  }
`;
